
import { Component, Vue } from 'vue-property-decorator';
import { getProjects } from '@/api/services/servers';

@Component
export default class InnerUrlRedirect extends Vue {
  loading = true;
  error = '';

  async created() {
    const innerUrl = this.$route.params.name;
    try {
      const { data } = await getProjects(0, 50, innerUrl);
      const project = data.results.find(p => p.inner_url === innerUrl);
      if (project) {
        this.$router.replace(`/projects/${project.id}`);
      } else {
        this.error = 'Проект не найден';
        this.loading = false;
      }
    } catch (e) {
      this.error = 'Ошибка при поиске проекта';
      this.loading = false;
    }
  }
}
